export default __webpack_public_path__ + "static/media/books2-afterB-768w.0dc5d30a.png";